import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/Control/InputTextarea';
import InputString from '../UI/Control/InputString';
import { useSelector } from 'react-redux'
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import MultiSelectList from '../UI/Control/MultiSelectList';
const SiteQuery = (props) => {
    let taskId = props.taskId;
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [arrSiteQRType, setArrSiteQRType] = useState([]);
    const [selQueryType, setSelQueryType] = useState('');

    useEffect(() => {
        FillSiteQueryTypeList();
    }, []);

    const SaveSiteQuery = (event) => {
        let objNotes = document.getElementById('txtNotes');
        if (props.Type.toLowerCase() != 'cims' && props.Type.toLowerCase() != 'cims-zelta' && objNotes.value.trim() == '') {
            alert('Notes should not be empty.');
            objNotes.focus();
            return false;
        }

        let otherQueryType = '';
        if (props.Type.toLowerCase() == 'cims-zelta' || props.Type.toLowerCase() == 'cims')
        {
            otherQueryType = document.getElementById('txtOtherQueryType').value;
        }

        let happyFoxID = '';
        if (props.Type.toLowerCase() == 'cims' || props.Type.toLowerCase() == 'cims-zelta') {
            happyFoxID = document.getElementById('txtHappyFoxID').value;
        }

        let objSiteQueryModel = {
            TaskID: taskId,
            Notes: objNotes.value,
            HappyFoxID: happyFoxID,
            CreationUser: EDCUserID,
            OtherQueryType: otherQueryType,
            QueryTypeIds: selQueryType.toString()
        };

        fetch('api/ImageService/SaveSiteQuery', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objSiteQueryModel)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Notes not saved, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })

    };

    const FillSiteQueryTypeList = () => {
        fetch('api/ImageService/FillSiteQueryTypeList')
            .then(response => response.json())
            .then(data => {
                setArrSiteQRType(data);
            });
    }

    const handleSiteQueryType = (e) => {
        var objMultiSelect = document.getElementById(e.target.id);
        var multiSelectValue = [...objMultiSelect.selectedOptions].map(option => option.value);
        setSelQueryType(multiSelectValue);
    };

    return (
        <div>
            {/*props.Type.toLowerCase() == 'cims' && <Row className="mt-2 mb-2">
                <Col md={1}> Notes: </Col>
                <Col md={6}>
                    <TextArea id="txtNotes" rows='5' cols='100' maxlength="2000" />
                </Col>
                <Col md={5}>
                    <Row className="mt-2 mb-2">
                        <Col md={3}>Happy Fox ID:</Col>
                        <Col md={7}><InputString id="txtHappyFoxID" width="100px" maxlength="249" /></Col>
                        <Col md={2}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveSiteQuery} > Submit </Button></Col>
                    </Row>
                </Col>
            </Row>*/}

            {(props.Type.toLowerCase() == 'cims-zelta' || props.Type.toLowerCase() == 'cims') &&
                <Row className="mt-2 mb-2">
                        <Col md={1}>Site Query Type<MandatoryLabel />: </Col>
                    <Col md={3}>
                        <MultiSelectList id="multiSiteQueryType" dataSource={arrSiteQRType} isMultiSelect="true" size="6" onChangeHandler={handleSiteQueryType}></MultiSelectList>
                        <Row className="mt-2 mb-2">
                            <Col md={2}>Other:</Col>
                            <Col md={10}><InputString id="txtOtherQueryType" width="100px" maxlength="249" /></Col>
                        </Row>
                    </Col>
                    <Col md={8}>
                        <Row className="mt-2 mb-2">
                            <Col md={2}>Happy Fox ID:</Col>
                            <Col md={5}><InputString id="txtHappyFoxID" width="100px" maxlength="249" /></Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                            <Col md={2}> Notes: </Col>
                            <Col md={8}>
                                <TextArea id="txtNotes" rows='5' cols='100' maxlength="2000" />
                            </Col>
                            <Col md={1}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveSiteQuery} > Submit </Button></Col>
                        </Row>
                    </Col>
                </Row>
            }

            {props.Type.toLowerCase() == 'lucidity' && <Row className="mt-2 mb-2">
                <Col md={1}> Notes<MandatoryLabel />: </Col>
                <Col md={9}>
                    <TextArea id="txtNotes" rows='5' cols='100' maxlength="2000" />
                </Col>
                <Col md={2}>
                    <Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveSiteQuery} > Submit </Button>
                </Col>
            </Row>}

        </div>
    );
}
export default SiteQuery;
